import { reactive } from "vue";
import echo from "@/echos";

export const connectionState = reactive({
  current: "initializing",
});

export function watchConnectionState(onReconnect) {
  const connection = echo.connector.pusher.connection;

  connectionState.current = connection.state;

  connection.bind("state_change", (states) => {
    connectionState.current = states.current;

    const wasDown =
      states.previous === "unavailable" || states.previous === "disconnected";
    const isUp = states.current === "connected";

    if (wasDown && isUp) {
      onReconnect();
    }
  });
}
